module.exports = __webpack_public_path__ + "img/about-bcfn-foundation.jpg?ee1755f4b9600484f81a83fb8b117c24";